import setupAxios from '../config/axios';

const axios = setupAxios();

export default axios;
